import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { CoachDto, CompleteCoachProfileDto, CreateUpdateCoachDto, GetCoachListDto } from '../../contracts/dtos/coaches/models';

@Injectable({
  providedIn: 'root',
})
export class CoachService {
  apiName = 'Default';
  

  completeProfile = (input: CompleteCoachProfileDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CoachDto>({
      method: 'POST',
      url: '/api/app/coach/complete-profile',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  create = (input: CreateUpdateCoachDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CoachDto>({
      method: 'POST',
      url: '/api/app/coach',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  decrementStudentCount = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'POST',
      url: `/api/app/coach/${id}/decrement-student-count`,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/coach/${id}`,
    },
    { apiName: this.apiName,...config });
  

  get = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CoachDto>({
      method: 'GET',
      url: `/api/app/coach/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getActiveCoaches = (input: GetCoachListDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<CoachDto>>({
      method: 'GET',
      url: '/api/app/coach/active-coaches',
      params: { filter: input.filter, specializationIds: input.specializationIds, isActive: input.isActive, isAcceptingStudents: input.isAcceptingStudents, minExperienceYears: input.minExperienceYears, maxExperienceYears: input.maxExperienceYears, minRating: input.minRating, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getByUserId = (userId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CoachDto>({
      method: 'GET',
      url: `/api/app/coach/by-user-id/${userId}`,
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetCoachListDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<CoachDto>>({
      method: 'GET',
      url: '/api/app/coach',
      params: { filter: input.filter, specializationIds: input.specializationIds, isActive: input.isActive, isAcceptingStudents: input.isAcceptingStudents, minExperienceYears: input.minExperienceYears, maxExperienceYears: input.maxExperienceYears, minRating: input.minRating, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  incrementStudentCount = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'POST',
      url: `/api/app/coach/${id}/increment-student-count`,
    },
    { apiName: this.apiName,...config });
  

  update = (id: string, input: CreateUpdateCoachDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CoachDto>({
      method: 'PUT',
      url: `/api/app/coach/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
  

  updateAcceptingStudents = (id: string, isAcceptingStudents: boolean, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'PUT',
      url: `/api/app/coach/${id}/accepting-students`,
      params: { isAcceptingStudents },
    },
    { apiName: this.apiName,...config });
  

  updateCoachStatus = (id: string, isActive: boolean, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'PUT',
      url: `/api/app/coach/${id}/coach-status`,
      params: { isActive },
    },
    { apiName: this.apiName,...config });
  

  updateRating = (id: string, rating: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'PUT',
      url: `/api/app/coach/${id}/rating`,
      params: { rating },
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
